import React from 'react'
import {
  AlignmentOptions,
  AnimatedCheckMark,
  Flex,
  LoadingSpinner,
  Text,
  TextType,
} from '@sendoutcards/quantum-design-ui'
import { useCallback, useSelector } from 'src/hooks'
import styles from './membershipRewardsWidget.module.scss'
import { useRewardsHistory } from 'src/react_query'
import { isExpiringSoon } from './MembershipRewardsWidget'
import InfiniteScroller from 'src/chrome/InfiniteScroller/InfiniteScroller'
import { formatDate } from 'src/helpers/formatDate'

export const MembershipRewardsList: React.FC<{}> = () => {
  const isMobile = useSelector(state => state.window.width <= 520)

  const { data, isFetching, hasNextPage, fetchNextPage } = useRewardsHistory({
    first: 20,
  })

  const rewards = data?.pages.flatMap(page =>
    page!.edges.map(edge => {
      const reward = edge?.node
      return reward
        ? {
            count: reward.count,
            originalQty: reward.originalQty,
            purchaseDate: new Date(reward.purchaseDate),
            expireDate: new Date(reward.expires),
          }
        : null
    }),
  )

  const handleLoadMore = useCallback(() => {
    fetchNextPage()
    // eslint-disable-next-line
  }, [])

  return (
    <InfiniteScroller
      hasMore={!!hasNextPage}
      isLoading={isFetching}
      loader={<LoadingSpinner size="xLarge" />}
      endMessage={
        <div className={styles.infiniteScrollerEndMessage}>
          <AnimatedCheckMark size="small" />
          <Text type="body">All rewards loaded.</Text>
        </div>
      }
      loadMore={handleLoadMore}
    >
      {rewards
        ? rewards.map((reward, i) => {
            if (reward) {
              const isExpSoon = isExpiringSoon(reward)
              const baseTextProps = {
                type: 'caption' as TextType,
                alignment: isMobile
                  ? ('left' as AlignmentOptions)
                  : ('center' as AlignmentOptions),
                style: {
                  color: isExpSoon ? 'red' : '#404040',
                },
              }
              return (
                <Flex width="100%" alignItems="space-between" key={i}>
                  <div
                    className={`${styles.bucketLine} ${styles.detailedListLine}`}
                  >
                    <div className={styles.titleAvailable}>
                      <Text {...baseTextProps} content="Available" />
                    </div>
                    <div className={styles.titleTotal}>
                      <Text {...baseTextProps} content="Original Amount" />
                    </div>
                    <div className={styles.titleAcquiredAt}>
                      <Text {...baseTextProps} content="Acquired Date" />
                    </div>
                    <div className={styles.titleExpiresAt}>
                      <Text {...baseTextProps} content="Expiration Date" />
                    </div>
                    <div className={styles.availableAmount}>
                      <Text
                        {...baseTextProps}
                        content={reward.count}
                        weight="bold"
                      />
                    </div>
                    <div className={styles.bucketTotal}>
                      <Text
                        {...baseTextProps}
                        content={reward.originalQty}
                        weight="bold"
                      />
                    </div>
                    <div className={styles.bucketAcquiredAt}>
                      <Text
                        {...baseTextProps}
                        content={formatDate(reward.purchaseDate, true)}
                        weight="bold"
                      />
                    </div>
                    <div className={styles.bucketExpiresAt}>
                      <Text
                        {...baseTextProps}
                        content={formatDate(reward.expireDate, true)}
                        weight="bold"
                      />
                    </div>
                  </div>
                </Flex>
              )
            } else {
              return <></>
            }
          })
        : null}
    </InfiniteScroller>
  )
}

export default MembershipRewardsList
